// [ai] Continue: a quiet pill in the top bar after the crumb — ▶ · Continue · title · m:ss · ✕; on a phone only ▶ · m:ss. Gone while the player is open.
import { fmt } from "../core/time";
import { usePlayer } from "../stores/player";
import { useIn, usePlayerCtl } from "./context";
import { Icon } from "./icons";
export function Resume() {
  const p = usePlayerCtl(); const r = usePlayer(s => s.resume); const open = usePlayer(s => !!s.now.item || s.now.noteOnly); const on = useIn();
  if (!r || open) return null;
  return (
    <div className={"ds-resume" + (on ? " in" : "")}>
      <button type="button" className="ds-resume-main" title={`Continue ${r.item.title} at ${fmt(r.t)}`} onClick={() => p.resumePlay()}><Icon name="play" /><span className="ds-resume-x"><b>Continue</b><span className="ds-resume-t">{r.item.title}</span><span className="ds-resume-m">{fmt(r.t)}</span></span></button>
      <button type="button" className="ds-resume-close" aria-label="Dismiss" onClick={() => p.resumeDismiss()}><Icon name="close" /></button>
    </div>
  );
}
